import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

type Props = ClassAttributes<HTMLElement> & {
  size?: number;
  className?: string;
};

const YahooIcon = ({ size, className }: Props) => {
  const Root = styled('img')({
    width: size || 24,
    height: size || 24,
  });
  return <Root className={className} src="/assets/yahoo.png" />;
};

export default YahooIcon;
